import { NodeType } from "~/lib/pipeline";
import { NodeTypes } from "@xyflow/react";

import { default as CommandStepNode } from "~/components/Playground/Node/CommandStepNode";
import { default as WaitStepNode } from "~/components/Playground/Node/WaitStepNode";
import { default as InputStepNode } from "~/components/Playground/Node/InputStepNode";
import { default as RootNode } from "~/components/Playground/Node/RootNode";
import { default as GroupStepNode } from "~/components/Playground/Node/GroupStepNode";
import { default as TriggerStepNode } from "~/components/Playground/Node/TriggerStepNode";

/**
 * A map of node types to their corresponding React components.
 */
export const nodeTypes: NodeTypes = {
  [NodeType.Root]: RootNode,
  [NodeType.Command]: CommandStepNode,
  [NodeType.Input]: InputStepNode,
  [NodeType.Wait]: WaitStepNode,
  [NodeType.Block]: InputStepNode,
  [NodeType.Group]: GroupStepNode,
  [NodeType.Trigger]: TriggerStepNode,
};
